import { useSyncExternalStore } from 'react'
import {
  getClikArtPlacementOverridesSnapshot,
  subscribeClikArtPlacementOverrides,
} from '@/lib/clikart/clikart-placement-session'

/** This session's per-art placed overrides (artId -> placed), live across spreads. */
export function useClikArtPlacementOverrides(): ReadonlyMap<string, boolean> {
  return useSyncExternalStore(
    subscribeClikArtPlacementOverrides,
    getClikArtPlacementOverridesSnapshot,
    getClikArtPlacementOverridesSnapshot
  )
}
